<h1
	class="obg-m-terms-and-conditions-history-header"
	test-id="obg-m-terms-and-conditions-history-header"
	[innerHTML]="(alternativeHeaderJurisdictions?.includes(jurisdiction)
		? 'terms-and-conditions.history-header-alternative'
		: 'terms-and-conditions.history-header') | translate"
></h1>

<mat-table class="obg-m-terms-and-conditions-history-table" [dataSource]="dataSource">
	<ng-container matColumnDef="description">
		<mat-header-cell *matHeaderCellDef
			>{{ "terms-and-conditions.history-description-title" | translate }}</mat-header-cell
		>
		<mat-cell *matCellDef="let item">{{ item.majorVersion }}.{{ item.minorVersion }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="issuedOn">
		<mat-header-cell *matHeaderCellDef
			>{{ "terms-and-conditions.history-issued-date" | translate }}</mat-header-cell
		>
		<mat-cell *matCellDef="let item">{{ item.effectiveFrom | date: 'dd-MM-YYYY hh:mm:ss' }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="acceptedOn">
		<mat-header-cell *matHeaderCellDef
			>{{ "terms-and-conditions.history-accepted-date" | translate }}</mat-header-cell
		>
		<mat-cell *matCellDef="let item">{{ item.acceptedAt | date: 'dd-MM-YYYY hh:mm:ss' }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="documentLink">
		<mat-header-cell *matHeaderCellDef
			>{{ "terms-and-conditions.history-document-link" | translate }}</mat-header-cell
		>

		<mat-cell *matCellDef="let item, let i = index">
			<button
				class="obg-m-terms-and-conditions-history-button-download"
				*ngIf="isDownloadLatestAcceptedContentEnabled && (i === 0); else viewButtonTemplate"
				(click)="onDownloadTermsAndConditionsClick()"
			>
				{{ "terms-and-conditions.history-download-version" | translate }}
			</button>

			<ng-template #viewButtonTemplate>
				<a class="obg-m-terms-and-conditions-history-button-view" href="#" (click)="openModal(item)"
					>{{ "terms-and-conditions.history-open-version" | translate }}
				</a>
			</ng-template>
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let item; columns: displayedColumns;"></mat-row>
</mat-table>
